import {
  DEFAULT_PICKER_DISPLAY,
  PICKER_DISPLAY_CONFIG,
} from '~/scopes/product-core/components/presentationals/CustomizationFunnelCondensed/CustomizationFunnelCondensed.constants'
import type { PickerDisplayConfig } from '~/scopes/product-core/components/presentationals/CustomizationFunnelCondensed/CustomizationFunnelCondensed.types'
import { getCondensedFunnelCategory } from '~/scopes/product-core/components/presentationals/CustomizationFunnelCondensed/composables/useCondensedFunnelExperiment/getCondensedFunnelCategory'

/**
 * Resolves the picker display config for a category / picker combination.
 *
 * Falls back to the default display (STACKED) when nothing is specified
 * for the category or the picker. When the config defines `maxOptions`
 * and the picker has more options than that, falls back to STACKED.
 */
export function getPickerColConfig(
  categoryId: string,
  pickerId: string,
  optionsCount?: number,
): PickerDisplayConfig {
  const categoryKey = getCondensedFunnelCategory(categoryId)

  if (!categoryKey) {
    return { display: DEFAULT_PICKER_DISPLAY }
  }

  const config = PICKER_DISPLAY_CONFIG[pickerId]?.[categoryKey]

  if (!config) {
    return { display: DEFAULT_PICKER_DISPLAY }
  }

  if (
    config.maxOptions !== undefined &&
    optionsCount !== undefined &&
    optionsCount > config.maxOptions
  ) {
    return { display: DEFAULT_PICKER_DISPLAY }
  }

  return config
}
